// pages/CreateCategory.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 更新为useNavigate
import { createCategory } from '../api'; // 假设有一个createCategory函数

function CreateCategory() {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const navigate = useNavigate(); // 使用useNavigate代替useHistory

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      await createCategory({ name, description });
      alert('Category created successfully!');
      navigate('/categories', { replace: true }); // 使用navigate进行重定向
    } catch (error) {
      console.error('Error creating category:', error);
      alert('Failed to create category.');
    }
  };

  return (
    <div>
      <h1>Create a New Category</h1>
      <form onSubmit={handleSubmit}>
        <label>
          Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <br />
        <label>
          Description:
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>
        <br />
        <button type="submit">Create Category</button>
      </form>
    </div>
  );
}

export default CreateCategory;